import * as React from "react";
const SvgTrails = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M16.1667 3L12 9.55L7.83333 3L2 12.1667L7.83333 21.3333L12 14.7833L16.1667 21.3333L22 12.1667L16.1667 3Z",
	fill: "#1E528C"
}));
export default SvgTrails;
